import _extends from 'babel-runtime/helpers/extends';

import E from 'wangeditor';
import { getToken } from '@/utils/auth';
import { v2Host } from '@/config/host';

export default {
  name: 'MainEditor',
  componentName: 'MainEditor',
  props: {
    config: {
      type: Object,
      required: true
    },
    formValue: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      editorLoading: false
    };
  },


  computed: {
    innerConfig: function innerConfig() {
      var params = _extends({}, this.config.params);
      return _extends({}, this.config, {
        params: params
      });
    },
    formItemStyle: function formItemStyle() {
      var style = this.innerConfig.params.style || {};
      if (this.innerConfig.params.width) {
        style.width = this.innerConfig.params.width;
        if (typeof style.width === 'number') {
          style.width += 'px';
        }
      }
      return style;
    }
  },

  methods: {},

  mounted: function mounted() {
    var _this = this;

    var self = this;
    var editor = new E(this.$refs.editor);
    // editor.customConfig.uploadImgShowBase64 = true // 使用 base64 保存图片
    editor.customConfig.uploadImgServer = v2Host + '/upload/file';
    editor.customConfig.uploadFileName = 'file';
    editor.customConfig.uploadImgParams = {
      // 如果版本 <=v3.1.0 ，属性值会自动进行 encode ，此处无需 encode
      // 如果版本 >=v3.1.1 ，属性值不会自动 encode ，如有需要自己手动 encode
      local: 1,
      mod: 'website'
      // 配置 pasteFilterStyle
    };editor.customConfig.pasteFilterStyle = false; // 禁用粘贴时保留样式

    // 配置 pasteTextHandle
    editor.customConfig.pasteTextHandle = function (content) {
      // 使用正则表达式移除所有 HTML 标签
      return content.replace(/<[^>]+>/g, '');
    };
    // 自定义配置颜色（字体颜色、背景色）
    editor.customConfig.colors = ['#000000', '#eeece0', '#1c487f', '#4d80bf', '#c24f4a', '#8baa4a', '#7b5ba1', '#46acc8', '#f9963b', '#ffffff', '#FAC415', // 官网形象颜色
    '#F5AE00'];
    editor.customConfig.uploadImgHooks = {
      before: function before(xhr, editor, files) {
        self.editorLoading = true;
        // 图片上传之前触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，files 是选择的图片文件

        // 如果返回的结果是 {prevent: true, msg: 'xxxx'} 则表示用户放弃上传
        // return {
        //     prevent: true,
        //     msg: '放弃上传'
        // }
      },
      success: function success(xhr, editor, result) {
        self.editorLoading = false;
        // 图片上传并返回结果，图片插入成功之后触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
      },
      fail: function fail(xhr, editor, result) {
        self.editorLoading = false;
        // 图片上传并返回结果，但图片插入错误时触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
      },
      error: function error(xhr, editor) {
        self.editorLoading = false;
        // 图片上传出错时触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
      },
      timeout: function timeout(xhr, editor) {
        self.editorLoading = false;
        // 图片上传超时时触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
      },

      // 如果服务器端返回的不是 {errno:0, data: [...]} 这种格式，可使用该配置
      // （但是，服务器端返回的必须是一个 JSON 格式字符串！！！否则会报错）
      customInsert: function customInsert(insertImg, result, editor) {
        // 图片上传并返回结果，自定义插入图片的事件（而不是编辑器自动插入图片！！！）
        // insertImg 是插入图片的函数，editor 是编辑器对象，result 是服务器端返回的结果

        // 举例：假如上传图片成功后，服务器端返回的是 {url:'....'} 这种格式，即可这样插入图片：
        if (result.code !== 0) {
          self.$message({
            message: result.msg,
            type: 'warning'
          });
        } else {
          var url = result.data.url;
          var imgHTML = '<img src="' + url + '" alt="' + result.data.origin_name + '" title="' + result.data.origin_name + '" />';
          editor.cmd.do('insertHTML', imgHTML);
        }

        // result 必须是一个 JSON 格式字符串！！！否则报错
      }
    };
    editor.customConfig.uploadImgHeaders = {
      'Auth-Token': getToken()
    };
    editor.customConfig.withCredentials = true;
    editor.customConfig.onchange = function (html) {
      _this.$set(_this.formValue, _this.innerConfig.prop, html);
    };
    editor.create();
    setTimeout(function () {
      editor.txt.html(_this.formValue[_this.innerConfig.prop]);
    }, 1000);
    // editor.txt.html(this.formValue[this.innerConfig.prop])
  }
};